module.exports = __webpack_public_path__ + "media/invite-a-friend/invites-accepted-55709e34.png";